import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as PIXI from 'pixi.js'

const propTypes = {
    canvas: PropTypes.any,
    data: PropTypes.object.isRequired
}

const colors = {
    purple: '#FFFFFF',
    purple2: '#8085FF',
    white: '#FFFFFF',
    orange: '#FFFFFF'
}

const welcomeMessages = {
    1: '',
    2: ''
}

class Preview extends Component
{
    constructor(props)
    {
        super(props);
        this.app = this.props.canvas;
        this.first = true;
        this.elements = {};
        this.myRef =  React.createRef();
    }

    componentDidMount()
    {
        this.myRef.current.appendChild(this.app.view);
        //update
        var loader = PIXI.loader
            .add('/images/apn.png')
            .add('/images/phone.png')
            .add('/images/photo.png')
            .add('/images/template-bg-A1.png')
            .add('/images/template-bg-A2.png')
            .add('/images/template-bg-B1.png')
            .add('/images/template-bg-B2.png')
            .add('/images/template-bg-C1.png')
            .add('/images/template-bg-C2.png')
            .load( () => this.update() );
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps !== this.props)
            this.update();
    }

    update()
    {
        const { template, type, bg, title, city, date, weekday, checkIn, price, place, address, photos, fontSize } = this.props.data;
        const color = template === 'A' ? colors.purple : colors.white;
        const typeInt = Number.parseInt(type) || 0;

        this.canvasBg(bg);
        this.canvasBase(template, typeInt);
        this.canvasStatic(color, typeInt);
        this.canvasTitle(title.toString(), color);
        this.canvasCity(city.toUpperCase(), colors, fontSize);
        this.canvasDate(date, weekday.toUpperCase(), color);
        this.canvasCheck(checkIn, color);
        this.canvasPrice(price, color);
        this.canvasPlace(place, color);
        this.canvasAddress(address, color);
        this.canvasPhone(typeInt);
        this.canvasPhotos(typeInt, photos);
    }

    canvasBg(bg)
    {
        const exists = this.elements.bg ? true : false;

        if (exists)
        {
            if (bg.file)
                this.loadImage(bg.file)
                .then( res => {
                    this.elements.bg.texture = res;
                });

            this.elements.bg.scale.x = bg.scale;
            this.elements.bg.scale.y = bg.scale;
            return;
        }

    }

    canvasBase(template, type)
    {
        const exists = this.elements.base ? true : false;
        const variant = type === 4 ? 2 : 1;

        const file = PIXI.Texture.fromImage(`/images/posts/apn.png`);

        if (exists)
        {
            this.elements.base.texture = file;
            return;
        }

        this.elements.base = new PIXI.Sprite(file);
        this.app.stage.addChild(this.elements.base);
    }

    canvasStatic(color, type)
    {
        if (!this.first)
        {
            this.elements.check.style.fill = color;
            return;
        }

        const phoneFile = PIXI.Texture.fromImage(``);
        const speakerFile = PIXI.Texture.fromImage(``);

        speakerFile.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;

        //orange box
        this.elements.box = new PIXI.Graphics();
        this.elements.box.beginFill(0xf47920)
                        .drawRect(0, 0, 0, 0)
                        .endFill();
        //checkin text
        this.elements.check = new PIXI.Text('                ', {
            fontWeight: 300,
            fontSize: 43,
            fontFamily: 'Lato',
            fill: color,
            align: 'left',
        });

        this.elements.check.x = 65;
        this.elements.check.y = 793;

        //ingresso text
        this.elements.ingresso = new PIXI.Text('                 ', {
            fontWeight: 300,
            fontSize: 33,
            fontFamily: 'Lato',
            fill: color,
            align: 'left',
        });

        this.elements.ingresso.x = 65;
        this.elements.ingresso.y = 840;

        //price text
        this.elements.price = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 33,
            fontFamily: 'Lato',
            fill: color,
            align: 'left',
        });

        this.elements.price.x = this.elements.ingresso.x + this.elements.ingresso.width;
        this.elements.price.y = 840;

        //phone container
        this.elements.container = new PIXI.Container();
        this.elements.container.x = 630;
        this.elements.container.y = 230;
        //phone mockup
        this.elements.phone = new PIXI.Sprite(phoneFile);
        this.elements.phone.x = 0;
        this.elements.phone.y = 0;
        //text top on phone container
        this.elements.welcome = new PIXI.Text(welcomeMessages[type], {
            fontWeight: 300,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 396
        });

        this.elements.welcome.anchor.set(0.5, 0);
        this.elements.welcome.x = 160;
        this.elements.welcome.y = 170;

        //speaker A
        this.elements.speakerA = new PIXI.Container();
        this.elements.speakerA.x = 0;
        this.elements.speakerA.y = 220;
        //
        this.elements.borderA = new PIXI.Graphics();
        this.elements.borderA.lineStyle(0)
            .beginFill(0xFFFFFF, .2)
            .drawCircle(158, 160, 200)
            .endFill();

        this.elements.maskA = new PIXI.Graphics();
        this.elements.maskA.lineStyle(0)
            .beginFill(0xFF0000, 1)
            .drawCircle(158, 160, 200)
            .endFill();

        //
        this.elements.speakerAPicture = new PIXI.Sprite(speakerFile);
        this.elements.speakerAPicture.interactive = true;
        this.elements.speakerAPicture.buttonMode = true;
        this.elements.speakerAPicture.anchor.set(.5, .5);
        this.elements.speakerAPicture.x = 158;
        this.elements.speakerAPicture.y = 180;
        this.elements.speakerAPicture.scale.x  *= .8;
        this.elements.speakerAPicture.scale.y  *= .8;

        this.elements.speakerAPicture.mask = this.elements.maskA;

        this.elements.speakerAPicture
                .on('pointerdown', this.onDragStart)
                .on('pointerup', this.onDragEnd)
                .on('pointerupoutside', this.onDragEnd)
                .on('pointermove', this.onDragMove);

        //
        this.elements.speakerAName = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 35,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerAName.anchor.set(0.5, 0);
        this.elements.speakerAName.x = 160;
        this.elements.speakerAName.y = 360;
        //
        this.elements.speakerARole = new PIXI.Text('Role', {
            fontWeight: 300,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerARole.anchor.set(0.5, 0);
        this.elements.speakerARole.x = 160;

        //speaker B
        this.elements.speakerB = new PIXI.Container();
        this.elements.speakerB.x = 60;
        this.elements.speakerB.y = this.elements.speakerA.height + 20;
        this.elements.speakerB.scale.x *= .7;
        this.elements.speakerB.scale.y *= .7;

        this.elements.borderB = new PIXI.Graphics();
        this.elements.borderB.lineStyle(0)
            .beginFill(0xFFFFFF, .2)
            .drawCircle(198, 130, 130)
            .endFill();

        this.elements.maskB = new PIXI.Graphics();
        this.elements.maskB.lineStyle(0)
            .beginFill(0xFF0000, 1)
            .drawCircle(198, 130, 120)
            .endFill();
        //
        this.elements.speakerBPicture = new PIXI.Sprite(speakerFile);
        this.elements.speakerBPicture.interactive = true;
        this.elements.speakerBPicture.buttonMode = true;
        this.elements.speakerBPicture.anchor.set(.5, .5);
        this.elements.speakerBPicture.x = 198;
        this.elements.speakerBPicture.y = 130;
        this.elements.speakerBPicture.scale.x  *= .8;
        this.elements.speakerBPicture.scale.y  *= .8;

        this.elements.speakerBPicture.mask = this.elements.maskB;

        this.elements.speakerBPicture
                .on('pointerdown', this.onDragStart)
                .on('pointerup', this.onDragEnd)
                .on('pointerupoutside', this.onDragEnd)
                .on('pointermove', this.onDragMove);
        //
        this.elements.speakerBName = new PIXI.Text('', {
            fontWeight: 700,
            fontSize: 35,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerBName.anchor.set(0.5, 0);
        this.elements.speakerBName.x = 200;
        this.elements.speakerBName.y = 280;
        //
        this.elements.speakerBRole = new PIXI.Text('Role', {
            fontWeight: 700,
            fontSize: 25,
            fontFamily: 'Lato',
            fill: colors.white,
            align: 'center',
            wordWrap: true,
            wordWrapWidth: 300
        });

        this.elements.speakerBRole.anchor.set(0.5, 0);
        this.elements.speakerBRole.x = 200;

        this.app.stage.addChild(this.elements.box,
                                this.elements.check,
                                this.elements.ingresso,
                                this.elements.price,
                                this.elements.container);
        this.elements.container.addChild(this.elements.phone,
                                    this.elements.welcome,
                                    this.elements.speakerA,
                                    this.elements.speakerB);
        this.elements.speakerA.addChild(this.elements.borderA,
                                    this.elements.maskA,
                                    this.elements.speakerAPicture,
                                    this.elements.speakerAName,
                                    this.elements.speakerARole);
        this.elements.speakerB.addChild(this.elements.borderB,
                                    this.elements.maskB,
                                    this.elements.speakerBPicture,
                                    this.elements.speakerBName,
                                    this.elements.speakerBRole);


        this.first = false;
    }

    canvasTitle(text, color)
    {
        const exists = this.elements.title ? true : false;

        if (exists)
        {
            this.elements.title.text = text;
            this.elements.title.style.fill = color;
            return;
        }

        this.elements.title = new PIXI.Text(text, {
                fontWeight: 300,
                fontSize: 50,
                fontFamily: 'Lato',
                fill: color,
                align: 'center',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.title.x = 125;
            this.elements.title.y = 328;

            this.app.stage.addChild(this.elements.title);
    }

    canvasCity(text, color, fontSize)
    {
        const exists = this.elements.city ? true : false;

        if (exists)
        {
            this.elements.city.text = text;
            this.elements.city.style.fontSize = fontSize;
            this.elements.city.style.fill = colors.purple2;
            return;
        }


            this.elements.city = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 80,
                fontFamily: 'Lato',
                fill: colors.purple2,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.city.anchor.set(0, 0.5);
            this.elements.city.x = 55;
            this.elements.city.y = 530;

            this.app.stage.addChild(this.elements.city);
    }

    canvasDate(textA, textB, color)
    {
        const exists = this.elements.date ? true : false;
        const text = textA ? `${textA} - ${textB}` : '';

        if (exists)
        {
            this.elements.date.text = text;
            this.elements.date.style.fill = color;
            return;
        }

            this.elements.date = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 60,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
            });

            this.elements.date.x = 65;
            this.elements.date.y = 730;

            this.app.stage.addChild(this.elements.date);
    }

    canvasCheck(text, color)
    {
        const exists = this.elements.hour ? true : false;

        if (exists)
        {
            this.elements.hour.text = text;
            this.elements.hour.style.fill = color;
            return;
        }

            this.elements.hour = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 43,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.hour.x = this.elements.check.x + this.elements.check.width + 10;
            this.elements.hour.y = this.elements.check.y;

            this.app.stage.addChild(this.elements.hour);
    }

    canvasPrice(text, color)
    {
        this.elements.price.text = text;
        this.elements.price.style.fill = color;
        this.elements.ingresso.style.fill = color;
    }

    canvasPlace(text, color)
    {
        const exists = this.elements.place ? true : false;

        if (exists)
        {
            this.elements.place.text = text;
            this.elements.place.style.fill = color;
            return;
        }

        this.elements.place = new PIXI.Text(text, {
                fontWeight: 900,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: color,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 550
            });

            this.elements.place.x = 65;
            this.elements.place.y = 940;

            this.app.stage.addChild(this.elements.place);
    }

    canvasAddress(text, color)
    {
        const exists = this.elements.address ? true : false;

        if (exists)
        {
            this.elements.address.text = text;
            this.elements.address.style.fill = color;
            return;
        }

        this.elements.address = new PIXI.Text(text, {
                fontWeight: 400,
                fontSize: 30,
                fontFamily: 'Lato',
                fill: colors.purple,
                align: 'left',
                wordWrap: true,
                wordWrapWidth: 600
            });

            this.elements.address.x = 65;
            this.elements.address.y = 980;

            this.app.stage.addChild(this.elements.address);
    }

    canvasPhone(type)
    {
        if (type <= 2)
        {
            this.elements.container.visible = true;
            this.elements.welcome.text = welcomeMessages[type];
        }
        else
            this.elements.container.visible = false;

    }

    canvasPhotos(type, speaker)
    {
        let scale;

        if (type === 1 )
        {
            this.elements.speakerA.x = 0;
            this.elements.speakerA.y = 250;
            this.elements.speakerA.scale.x = 1;
            this.elements.speakerA.scale.y = 1;
            this.elements.speakerB.visible = false;
        }
        else
        {
            this.elements.speakerA.x = 60;
            this.elements.speakerA.y = 200;
            this.elements.speakerA.scale.x = .7;
            this.elements.speakerA.scale.y = .7;
            this.elements.speakerB.visible = true;
        }

        if ( type <= 2 )
        {
            const speakerA = speaker[0] || {}
            scale = speakerA.scale || 1;
            this.elements.speakerAName.text = speakerA.name;
            this.elements.speakerARole.text = speakerA.role;
            this.elements.speakerARole.y = this.elements.speakerAName.y + this.elements.speakerAName.height;
            this.elements.speakerAPicture.scale.x = scale;
            this.elements.speakerAPicture.scale.y = scale;

            if (speakerA.file)
                this.loadImage(speakerA.file)
                .then( res => {
                    this.elements.speakerAPicture.texture = res;
                })
        }
        if ( type === 2 )
        {
            const speakerB = speaker[1] || {}
            scale = speakerB.scale || 1;
            this.elements.speakerB.y = this.elements.speakerA.y + this.elements.speakerA.height + 20;
            this.elements.speakerBName.text = speakerB.name;
            this.elements.speakerBRole.text = speakerB.role;
            this.elements.speakerBRole.y = this.elements.speakerBName.y + this.elements.speakerBName.height;
            this.elements.speakerBPicture.scale.x = scale;
            this.elements.speakerBPicture.scale.y = scale;

            if (speakerB.file )
                this.loadImage(speakerB.file)
                .then( res => {
                    this.elements.speakerBPicture.texture = res;
                })
        }

    }

    onDragStart(event)
    {
        this.draggingData = event.data;
        let position = this.draggingData.getLocalPosition(this);
        this.pivot.set(position.x, position.y);
        this.position.set(this.draggingData.global.x, this.draggingData.global.y);
        this.dragging = true;

        var newPosition = this.draggingData.getLocalPosition(this.parent);
        this.x = newPosition.x;
        this.y = newPosition.y;

    }

    onDragEnd()
    {
        this.dragging = false;
        this.draggingData = null;
    }

    onDragMove()
    {
        if (this.dragging)
        {
            var newPosition = this.draggingData.getLocalPosition(this.parent);
            this.x = newPosition.x;
            this.y = newPosition.y;
        }
    }

    loadImage(src)
    {

        return new Promise ( (resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function(e)
            {
                let file = PIXI.Texture.fromImage(e.target.result);
                resolve(file);
            }
            reader.readAsDataURL(src);
        });
    }

    render()
    {
        return (
            <div
                className='preview'
                ref={ this.myRef }
            >
            </div>
        )
    }

}

Preview.propTypes = propTypes;

export default Preview;